"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var index_1 = require("../../index");

require("./index.css");

var TriPaneContext = react_1.default.createContext();

var useTriPaneContext = function () {
  var context = react_1.default.useContext(TriPaneContext);

  if (!context) {
    throw new Error('TriPane compound components cannot be rendered outside the TriPane component');
  }

  return context;
};

var TriPane = function (_a) {
  var _b = _a.initialPaneOneAvailable,
      initialPaneOneAvailable = _b === void 0 ? true : _b,
      _c = _a.initialPaneTwoAvailable,
      initialPaneTwoAvailable = _c === void 0 ? true : _c,
      _d = _a.initialPaneThreeAvailable,
      initialPaneThreeAvailable = _d === void 0 ? true : _d,
      onChange = _a.onChange,
      children = _a.children;

  var _e = (0, react_1.useState)(initialPaneOneAvailable),
      paneOneVisible = _e[0],
      setPaneOneVisible = _e[1];

  var _f = (0, react_1.useState)(initialPaneTwoAvailable),
      paneTwoVisible = _f[0],
      setPaneTwoVisible = _f[1];

  var _g = (0, react_1.useState)(initialPaneThreeAvailable),
      paneThreeVisible = _g[0],
      setPaneThreeVisible = _g[1];

  var firstRender = (0, react_1.useRef)(true);
  (0, react_1.useEffect)(function () {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    onChange({
      paneOneVisible: paneOneVisible,
      paneTwoVisible: paneTwoVisible,
      paneThreeVisible: paneThreeVisible
    });
  }, [paneOneVisible, paneTwoVisible, paneThreeVisible, onChange]);

  var togglePaneOneVisibility = function () {
    var toggledVisibility = !paneOneVisible;
    setPaneOneVisible(toggledVisibility);
  };

  var togglePaneTwoVisibility = function () {
    var toggledVisibility = !paneTwoVisible;
    setPaneTwoVisible(toggledVisibility);
  };

  var togglePaneThreeVisibility = function () {
    var toggledVisibility = !paneThreeVisible;
    setPaneThreeVisible(toggledVisibility);
  };

  var visiblePaneCount = [paneOneVisible, paneTwoVisible, paneThreeVisible].filter(function (v) {
    return v;
  }).length;
  var isLastVisiblePane = visiblePaneCount === 1;
  var providerValue = {
    initialPaneOneAvailable: initialPaneOneAvailable,
    initialPaneTwoAvailable: initialPaneTwoAvailable,
    initialPaneThreeAvailable: initialPaneThreeAvailable,
    paneOneVisible: paneOneVisible,
    paneTwoVisible: paneTwoVisible,
    paneThreeVisible: paneThreeVisible,
    togglePaneOneVisibility: togglePaneOneVisibility,
    togglePaneTwoVisibility: togglePaneTwoVisibility,
    togglePaneThreeVisibility: togglePaneThreeVisibility,
    isLastVisiblePane: isLastVisiblePane
  };
  return (0, jsx_runtime_1.jsx)(TriPaneContext.Provider, __assign({
    value: providerValue
  }, {
    children: (0, jsx_runtime_1.jsx)("div", __assign({
      className: "panes-" + visiblePaneCount
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var HeaderContent = function (_a) {
  var children = _a.children;

  var _b = useTriPaneContext(),
      paneOneVisible = _b.paneOneVisible,
      paneTwoVisible = _b.paneTwoVisible;

  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: "tri-pane-header" + (!paneOneVisible && !paneTwoVisible ? ' description-only' : '')
  }, {
    children: children
  }), void 0);
};

HeaderContent.propTypes = {
  children: prop_types_1.default.node
};
HeaderContent.defaultProps = {
  children: null
};

var SourceContent = function (_a) {
  var children = _a.children;

  var _b = useTriPaneContext(),
      paneOneVisible = _b.paneOneVisible,
      paneTwoVisible = _b.paneTwoVisible;

  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: "related-data" + (!paneOneVisible && !paneTwoVisible ? ' description-only' : '')
  }, {
    children: children
  }), void 0);
};

SourceContent.propTypes = {
  children: prop_types_1.default.node
};
SourceContent.defaultProps = {
  children: null
};

var PaneOne = function (_a) {
  var children = _a.children;
  var paneOneVisible = useTriPaneContext().paneOneVisible;
  var paneOneContent = (0, jsx_runtime_1.jsx)("section", __assign({
    "aria-label": "table pane",
    className: "pane"
  }, {
    children: children
  }), void 0);
  return paneOneVisible ? paneOneContent : null;
};

var PaneTwo = function (_a) {
  var children = _a.children;
  var paneTwoVisible = useTriPaneContext().paneTwoVisible;
  var paneTwoContent = (0, jsx_runtime_1.jsx)("section", __assign({
    "aria-label": "chart pane",
    className: "pane"
  }, {
    children: children
  }), void 0);
  return paneTwoVisible ? paneTwoContent : null;
};

var PaneThree = function (_a) {
  var children = _a.children;
  var paneThreeVisible = useTriPaneContext().paneThreeVisible;
  var paneThreeContent = (0, jsx_runtime_1.jsx)("section", __assign({
    "aria-label": "description pane",
    className: "pane padded"
  }, {
    children: children
  }), void 0);
  return paneThreeVisible ? paneThreeContent : null;
};

var Controls = function () {
  var _a = useTriPaneContext(),
      initialPaneOneAvailable = _a.initialPaneOneAvailable,
      initialPaneTwoAvailable = _a.initialPaneTwoAvailable,
      initialPaneThreeAvailable = _a.initialPaneThreeAvailable,
      paneOneVisible = _a.paneOneVisible,
      paneTwoVisible = _a.paneTwoVisible,
      paneThreeVisible = _a.paneThreeVisible,
      togglePaneOneVisibility = _a.togglePaneOneVisibility,
      togglePaneTwoVisibility = _a.togglePaneTwoVisibility,
      togglePaneThreeVisibility = _a.togglePaneThreeVisibility,
      isLastVisiblePane = _a.isLastVisiblePane;

  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: "tri-pane-control",
    "data-testid": "tri-pane-control"
  }, {
    children: (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "wrapper"
    }, {
      children: [initialPaneOneAvailable && (0, jsx_runtime_1.jsxs)("label", __assign({
        htmlFor: "table"
      }, {
        children: [(0, jsx_runtime_1.jsx)("input", {
          type: "checkbox",
          id: "table",
          name: "table",
          "data-testid": "tri-pane-table",
          defaultChecked: paneOneVisible,
          onClick: togglePaneOneVisibility,
          onKeyPress: togglePaneOneVisibility,
          disabled: isLastVisiblePane && paneOneVisible
        }, void 0), (0, jsx_runtime_1.jsx)(index_1.Tooltip, __assign({
          direction: "bottom",
          dataTestId: "tri-pane-table-tooltip",
          tip: (paneOneVisible ? "" + (isLastVisiblePane ? 'Cannot Hide ' : 'Hide ') : 'Show ') + "Table"
        }, {
          children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
            name: "table",
            width: "19",
            className: "fill " + (paneOneVisible ? 'icon-orange-theme hover-orange-tripane' : 'icon-tripane-inactive hover-tripane-inactive-hover')
          }, void 0)
        }), void 0)]
      }), void 0), initialPaneTwoAvailable && (0, jsx_runtime_1.jsxs)("label", __assign({
        htmlFor: "chart"
      }, {
        children: [(0, jsx_runtime_1.jsx)("input", {
          type: "checkbox",
          id: "chart",
          name: "chart",
          "data-testid": "tri-pane-chart",
          defaultChecked: paneTwoVisible,
          onClick: togglePaneTwoVisibility,
          onKeyPress: togglePaneTwoVisibility,
          disabled: isLastVisiblePane && paneTwoVisible
        }, void 0), (0, jsx_runtime_1.jsx)(index_1.Tooltip, __assign({
          direction: "bottom",
          dataTestId: "tri-pane-chart-tooltip",
          tip: (paneTwoVisible ? "" + (isLastVisiblePane ? 'Cannot Hide ' : 'Hide ') : 'Show ') + "Chart"
        }, {
          children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
            name: "pie-chart",
            width: "19",
            className: "fill " + (paneTwoVisible ? 'icon-orange-theme hover-orange-tripane' : 'icon-tripane-inactive hover-tripane-inactive-hover')
          }, void 0)
        }), void 0)]
      }), void 0), initialPaneThreeAvailable && (0, jsx_runtime_1.jsxs)("label", __assign({
        htmlFor: "description"
      }, {
        children: [(0, jsx_runtime_1.jsx)("input", {
          type: "checkbox",
          id: "description",
          name: "description",
          "data-testid": "tri-pane-description",
          defaultChecked: paneThreeVisible,
          onClick: togglePaneThreeVisibility,
          onKeyPress: togglePaneThreeVisibility,
          disabled: isLastVisiblePane && paneThreeVisible
        }, void 0), (0, jsx_runtime_1.jsx)(index_1.Tooltip, __assign({
          direction: "bottom",
          dataTestId: "tri-pane-description-tooltip",
          tip: (paneThreeVisible ? "" + (isLastVisiblePane ? 'Cannot Hide ' : 'Hide ') : 'Show ') + "Text"
        }, {
          children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
            name: "text",
            width: "19",
            className: "fill " + (paneThreeVisible ? 'icon-orange-theme hover-orange-tripane' : 'icon-tripane-inactive hover-tripane-inactive-hover')
          }, void 0)
        }), void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
};

TriPane.PaneOne = PaneOne;
TriPane.PaneTwo = PaneTwo;
TriPane.PaneThree = PaneThree;
TriPane.Controls = Controls;
TriPane.HeaderContent = HeaderContent;
TriPane.SourceContent = SourceContent;
TriPane.propTypes = {
  initialPaneOneAvailable: prop_types_1.default.bool,
  initialPaneTwoAvailable: prop_types_1.default.bool,
  initialPaneThreeAvailable: prop_types_1.default.bool,
  onChange: prop_types_1.default.func,
  children: prop_types_1.default.node
};
TriPane.defaultProps = {
  initialPaneOneAvailable: true,
  initialPaneTwoAvailable: true,
  initialPaneThreeAvailable: true,
  onChange: function () {},
  children: null
};
exports.default = TriPane;